/*
 * WW Sigma ActionBar — sticky Pre-Order CTA behaviour
 * Author: Tayler — 2026-06-30
 * Version: 2.2.0 - 2026-07-29 15:35 (UTC+8) - Plaud Tayler — pre-order mechanism: sold-out
 * scroll-to-waitlist handler removed (popup owned by ww-sigma-preorder.js). Scroll-up: drops
 * below the theme's sticky header (is-below-header + --wsa-header-h) so the two never overlap.
 * The bar blur-fades in once the HERO section's bottom passes the viewport top.
 * One passive rAF-throttled scroll handler drives the state. Binds once.
 */
(function () {
  if (window.__wwSigmaActionbar) return;
  window.__wwSigmaActionbar = true;

  var ticking = false;

  function update() {
    ticking = false;
    var vh = window.innerHeight;
    var hero = document.querySelector('.ww-sigma-hero');
    var sticky = document.querySelector('.ww-sigma-actionbar--sticky');
    if (!hero || !sticky) return;

    if (sticky.__wl === undefined) sticky.__wl = document.querySelector('.ww-sigma-waitlist') || null;

    // reveal once the hero section has scrolled past the top edge of the viewport
    var leftTop = hero.getBoundingClientRect().bottom < 24;
    var waitlistInView = sticky.__wl ? (sticky.__wl.getBoundingClientRect().top < vh * 0.92) : false;
    sticky.classList.toggle('is-revealed', leftTop && !waitlistInView);

    // scroll-up: the theme's sticky header slides down over the viewport top-right — drop the
    // bar below it (class moves top by the measured header height) - Plaud Tayler - 2026-07-27
    if (sticky.__hd === undefined) sticky.__hd = document.querySelector('.section-header') || null;
    var hd = sticky.__hd;
    var headerShown = !!(hd && hd.classList.contains('shopify-section-header-sticky') && !hd.classList.contains('shopify-section-header-hidden'));
    if (headerShown) sticky.style.setProperty('--wsa-header-h', hd.offsetHeight + 'px');
    sticky.classList.toggle('is-below-header', headerShown);
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }

  // Removed: sold-out scroll-to-waitlist-section handler — after the pre-order rework the
  // sold-out state opens a popup owned by ww-sigma-preorder.js; the in-page section no longer exists - Plaud Tayler - 2026-07-29 15:35

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (document.readyState !== 'loading') update();
  else document.addEventListener('DOMContentLoaded', update);
  document.addEventListener('shopify:section:load', update);
})();
